import { render, staticRenderFns } from "./Mp.vue?vue&type=template&id=bfc1e372&scoped=true&"
import script from "./Mp.vue?vue&type=script&lang=js&"
export * from "./Mp.vue?vue&type=script&lang=js&"
import style0 from "./Mp.vue?vue&type=style&index=0&id=bfc1e372&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc1e372",
  null
  
)

export default component.exports